import React from "react";
import { useState } from "react";

const MatchResults = ({ matches, setCurrentStep, setShowStudentPlatform }) => {
  const randomProfilePhotos = [
    "https://randomuser.me/api/portraits/women/65.jpg",
    "https://randomuser.me/api/portraits/women/76.jpg",
    "https://randomuser.me/api/portraits/women/62.jpg",
    "https://randomuser.me/api/portraits/women/90.jpg",
    "https://randomuser.me/api/portraits/women/8.jpg",
    "https://randomuser.me/api/portraits/women/81.jpg",
    "https://randomuser.me/api/portraits/men/72.jpg",
    "https://randomuser.me/api/portraits/men/4.jpg",
    "https://randomuser.me/api/portraits/men/90.jpg",
    "https://randomuser.me/api/portraits/men/1.jpg",
    "https://randomuser.me/api/portraits/men/54.jpg",
    "https://randomuser.me/api/portraits/men/94.jpg",
    "https://randomuser.me/api/portraits/men/7.jpg",
  ];
  const [showFull, setShowFull] = useState(false);
  const toggleJustification = () => setShowFull(!showFull);
  const justification =
    "Optimized Learning Dynamics: Your preferred learning approach perfectly aligns with the tutor's tutoring approach, ensuring a cohesive and effective educational experience";

  return (
    <div className="student-platform-bg">
      {/* Beautiful Back Home Button !!!!*/}
      <button
        className="student-back-home-btn"
        onClick={() => {
          setShowStudentPlatform(false);
          setCurrentStep(0);
        }}>
        <span className="student-back-home-icon">←</span> Back to Home
      </button>

      <div className="student-step-slide student-step-animate">
        <div className="dashboard-header">
          <img src="/zentora-transparent-white.png" alt="Zentora Logo" className="dashboard-logo" />
          <h1 className="dashboard-title">Your Matches</h1>
        </div>
        <h1 className="platform-step-title">Matching Complete!</h1>
        <p className="platform-step-subtitle">Meet your top tutor matches — generated by Zentora's academic intelligence. </p>
        <div className="match-box-grid">
          {matches !== null &&
            Object.entries(matches).map(([subject, tutors]) => (
              <div key={subject} className="match-box">
                <h2 className="dashboard-section-title">{subject}</h2>
                <ul className="tutor-card-list">
                  {tutors.map((tutor, i) => (
                    <div
                      key={tutor.id}
                      className="tutor-card tutor-card-animate"
                      style={{ animationDelay: `${i * 0.25}s` }}>
                      <div className="tutor-info">
                        <img
                          src={randomProfilePhotos[Math.floor(Math.random() * 13)]}
                          alt="Tutor Avatar"
                          className="tutor-avatar"
                        />
                        <div className="tutor-meta">
                          <p className="tutor-name">
                            <strong>
                              {tutor.firstName} {tutor.lastName}
                            </strong>
                            <div className="match-score-badge">⭐ {tutor.score} Match</div>
                          </p>
                          <p className="tutor-email">{tutor.background[0]}</p>
                        </div>
                      </div>
                      <ul className="match-description">
                        {tutor.matchJustification.map((reason, i) => (
                          <li key={i}>
                            <span className="reveal-text" style={{ animationDelay: `${i * 0.15}s` }}>
                              <strong className="student-title-gradient">{reason.heading}: </strong>
                              {reason.description}
                            </span>
                          </li>
                        ))}
                      </ul>

                      {/* <p className="match-description">
                      {showFull ? justification : justification.slice(0, 120)}
                      {justification.length > 120 && (
                        <button className="read-more-btn" onClick={toggleJustification}>
                          {showFull ? "Show less" : "Read more"}
                        </button>
                      )}
                    </p> */}

                      <div className="tutor-footer">
                        <a href={tutor.introVideo} target="_blank" rel="noopener noreferrer" className="video-link">
                          ▶ Learn more about {tutor.firstName}
                        </a>
                        <button
                          className="choose-tutor-btn"
                          onClick={() => alert(`${tutor.firstName} ${tutor.lastName} selected!`)}>
                          ✅ Choose This Tutor
                        </button>
                      </div>
                    </div>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      </div>

      <style jsx>{`
        /* Page animation on load */
        .student-step-slide {
          animation: studentStepSlideIn 0.7s cubic-bezier(0.4, 0, 0.2, 1);
        }
        @keyframes studentStepSlideIn {
          from {
            opacity: 0;
            transform: translateY(48px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: none;
          }
        }
        .student-step-animate {
          animation: studentStepFadeIn 0.7s cubic-bezier(0.4, 0, 0.2, 1);
        }
        @keyframes studentStepFadeIn {
          from {
            opacity: 0;
            transform: translateY(32px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: none;
          }
        }
        .tutor-card-animate {
          animation: studentStepSlideIn 0.7s cubic-bezier(0.4, 0, 0.2, 1);
          opacity: 0;
          animation-fill-mode: forwards;
        }

        @keyframes revealLeftToRight {
          from {
            clip-path: inset(0 100% 0 0);
            opacity: 0;
          }
          to {
            clip-path: inset(0 0 0 0);
            opacity: 1;
          }
        }

        .reveal-text {
          display: block;
          animation: revealLeftToRight 1.2s ease-out forwards;
          opacity: 0;
        }

        .read-more-btn {
          margin-top: 8px;
          font-size: 0.9rem;
          background: none;
          border: none;
          color: #4c41f0;
          cursor: pointer;
          padding: 0;
        }

        .read-more-btn:hover {
          text-decoration: underline;
        }

        .tutor-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
        }

        .choose-tutor-btn {
          padding: 8px 12px;
          font-weight: 600;
          font-size: 0.95rem;
          border: none;
          cursor: pointer;
          background: linear-gradient(90deg, #4f8cff 0%, #a259ff 100%);
          color: #fff;
          border-radius: 32px;
          box-shadow: 0 4px 18px #a259ff22;
          transition: background 0.2s, transform 0.2s;
        }

        .choose-tutor-btn:hover {
          background: linear-gradient(90deg, #a259ff 0%, #4f8cff 100%);
          transform: translateY(-2px) scale(1.04);
        }

        .choose-tutor-btn:hover {
          background-color: #372fd1;
        }

        .video-link {
          color: #5a50edff;
          text-decoration: none;
          font-weight: 600;
          display: inline-block;
          margin-top: 4px;
        }

        .video-link:hover {
          text-decoration: underline;
        }

        .match-score-badge {
          display: inline-block;
          align-self: flex-start;
          background-color: #e7e3ff;
          color: #4c41f0;
          font-weight: 600;
          font-size: 0.85rem;
          padding: 6px 10px;
          border-radius: 12px;
          margin-left: 12px;
        }

        .tutor-info {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .tutor-avatar {
          width: 54px;
          height: 54px;
          border-radius: 50%;
          object-fit: cover;
          border: 2.5px solid #a259ff;
        }

        .tutor-meta {
          display: flex;
          flex-direction: column;
        }

        .match-box {
          background: rgba(255, 255, 255, 0.92);
          border-radius: 18px;
          box-shadow: 0 8px 40px #a259ff18, 0 0 0 2px #4f8cff11;
          padding: 28px;
          margin: 0 auto;
          margin-bottom: 32px;
          width: 100%;
          max-width: 500px;
        }

        .dashboard-section-title {
          font-size: 1.4rem;
          color: #4f8cff;
          margin-bottom: 20px;
        }

        .tutor-card-list {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .tutor-name {
          font-size: 1.05rem;
          margin: 0;
          color: #4c41f0;
        }

        .tutor-card {
          background: #f4f3ff;
          border-radius: 12px;
          padding: 16px 20px;
          box-shadow: 2px 4px 12px #a29fbe2e;
          color: #23273a;
        }

        .tutor-email {
          font-size: 0.9rem;
          color: #666;
          margin: 0;
        }

        .match-description {
          margin: 15px 0;
          color: #555;
        }

        .tutor-card .tutor-name {
          font-size: 1.1rem;
          margin-bottom: 4px;
          color: #4c41f0;
        }

        .match-box-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr); /* exactly 2 per row */
          gap: 0px;
          justify-items: center;
          width: 100%;
          max-width: 1300px;
          margin: 40px auto 0;
        }

        @media (max-width: 768px) {
          .match-box-grid {
            grid-template-columns: 1fr;
          }
        }

        .student-title-gradient {
          background: linear-gradient(90deg, #4f8cff 0%, #a259ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        /* Beautiful Back Home Button */
        .student-back-home-btn {
          position: fixed;
          top: 32px;
          left: 32px;
          z-index: 1201;
          background: linear-gradient(90deg, #4f8cff 0%, #a259ff 100%);
          color: #fff;
          border: none;
          border-radius: 32px;
          font-family: "FK Grotesk", sans-serif;
          font-weight: 600;
          font-size: 1.08rem;
          padding: 13px 32px 13px 22px;
          box-shadow: 0 4px 24px #a259ff33, 0 1.5px 6px #4f8cff22;
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
          outline: none;
        }
        .student-back-home-btn:hover,
        .student-back-home-btn:focus {
          background: linear-gradient(90deg, #a259ff 0%, #4f8cff 100%);
          box-shadow: 0 8px 32px #a259ff55, 0 2px 12px #4f8cff33;
          transform: translateY(-2px) scale(1.04);
        }
        .student-back-home-icon {
          font-size: 1.2em;
          margin-right: 6px;
          filter: drop-shadow(0 2px 8px #fff) drop-shadow(0 0 8px #a259ff33);
        }
        @media (max-width: 600px) {
          .student-back-home-btn {
            top: 12px;
            left: 8px;
            padding: 10px 18px 10px 14px;
            font-size: 0.98rem;
          }
        }

        .student-platform-bg {
          background: linear-gradient(120deg, #f3f3f7 0%, #e9e6ff 100%);
          min-height: 100vh;
          font-family: "FK Grotesk", sans-serif;
        }

        .dashboard-title {
          font-family: "PP Editorial", serif;
          font-size: 2.6rem;
          color: #23273a;
          background: linear-gradient(90deg, #4f8cff 0%, #a259ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .platform-step-title {
          font-family: "PP Editorial", serif;
          font-size: 2.2rem;
          font-weight: 400;
          color: #23273a;
          margin-bottom: 0;
          text-align: center;
        }
        .platform-step-subtitle {
          font-size: 1.2rem;
          color: #717480ff;
          margin-bottom: 30px;
          text-align: center;
          line-height: 1.6;
        }

        .dashboard-header {
          display: flex;
          align-items: center;
          gap: 18px;
          padding: 48px 0 24px 0;
          justify-content: center;
        }
        .dashboard-logo {
          width: 64px;
          height: 64px;
          object-fit: contain;
          filter: drop-shadow(0 8px 32px #a259ff44) drop-shadow(0 0 12px #fff8);
        }
      `}</style>
    </div>
  );
};

export default MatchResults;
